module.exports = __webpack_public_path__ + "static/media/download-grey.1beb8f9e.svg";